import ClientFormWizard from "rc-app/components/ClientForm/ClientFormWizard";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDesktopMode } from "rc-app/hooks/useDesktopMode";
import DesktopModePrompt from "rc-app/components/DesktopModePrompt";
// import MostSimpleUploadClean from "./MostSimpleUploadClean";
// import MostSimpleUpload from "./MostSimpleUpload";

function AddClient() {
  const navigate = useNavigate();
  const { showPrompt, accept, dismiss } = useDesktopMode();

  if (showPrompt) {
    return (
      <DesktopModePrompt
        message="The client form contains multi-step wizards and detailed fields that are best viewed in desktop mode. Switch to desktop view for the best experience."
        onAccept={accept}
        onGoBack={() => { dismiss(); navigate("/"); }}
      />
    );
  }

  return (
    <>
      <ClientFormWizard />
      {/* <MostSimpleUploadClean />
      <MostSimpleUpload /> */}
    </>
  );
}

export default AddClient;
